module.exports = __webpack_public_path__ + "static/img/透明底加亮.4dadfea7.png";